import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { doesSchoolExist, getLastSchoolID } from "state/teachers/selectors";
import { setLastSchool } from "state/teachers/actions";

import { Redirect } from "react-router";

import Gate from "components/Gate";

class MaintainValidSchoolID extends React.Component {
  
  static propTypes = {
    currentSchoolID: PropTypes.string,
    generatePath: PropTypes.func.isRequired
  }
  
  updateLastSchool() {
    const { currentSchoolID, isCurrentSchoolIDValid, lastSchoolID } = this.props;
    if (isCurrentSchoolIDValid && currentSchoolID !== lastSchoolID) {
      this.props.setLastSchool(currentSchoolID);
    }
  }
  
  componentDidMount() {
    this.updateLastSchool();
  }
  
  componentDidUpdate() {
    this.updateLastSchool();
  }
  
  render() {
    const { isCurrentSchoolIDValid, lastSchoolID } = this.props;
    const redirect = <Redirect to={this.props.generatePath(lastSchoolID)} />;
    return (
      <Gate isOpen={isCurrentSchoolIDValid} placeholder={redirect}>
        {this.props.children}
      </Gate>
    );
  }
  
}

export default connect(
  (state, ownProps) => {
    const { currentSchoolID } = ownProps;
    const isCurrentSchoolIDDefined = currentSchoolID !== undefined;
    return {
      isCurrentSchoolIDValid: isCurrentSchoolIDDefined && doesSchoolExist(state, currentSchoolID),
      lastSchoolID: getLastSchoolID(state)
    }
  },
  { setLastSchool }
)(MaintainValidSchoolID);



// WEBPACK FOOTER //
// ./src/components/teachers/MaintainValidSchoolID.js